<template>
  <v-app>
    <v-main>
      <menu-personalizado />

      <div>
        <slot></slot>
      </div>

      <footer-personalizado />
    </v-main>
  </v-app>
</template>

<script>
import MenuPersonalizado from '@/views/menu/MenuPersonalizado.vue'
import FooterPersonalizado from '@/views/footer/FooterPersonalizado.vue'

export default {
  components: {
    MenuPersonalizado,
    FooterPersonalizado,
  },
}
</script>
